import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("loading"); // loading | paid | pending

  useState(() => {
    if (!sessionId) { setState("pending"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
      } catch (_) { /* retry */ }
      tries += 1;
      if (tries < 15) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
  });

  return (
    <div data-testid="page-payment-success" className="min-h-screen bg-[#F2DFC6] flex items-center justify-center px-5">
      <div className="max-w-md w-full bg-[#FCF4E8] rounded-[1.75rem] border border-[#EAD0AE] p-10 text-center shadow-[0_30px_60px_-40px_rgba(60,34,19,0.25)]">
        {state === "loading" && (
          <>
            <Loader2 size={40} className="animate-spin text-[#93401D] mx-auto" />
            <h1 className="font-serif text-2xl text-[#29170C] mt-6">Zahlung wird geprüft…</h1>
            <p className="text-[#63432B] mt-3 text-[15px]">Einen Moment bitte, wir bestätigen deine Zahlung.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={44} strokeWidth={1.2} className="text-[#93401D] mx-auto" />
            <h1 className="font-serif text-3xl text-[#29170C] mt-6">Danke für deine Buchung!</h1>
            <p className="text-[#63432B] mt-4 leading-relaxed text-[15px]">
              Deine Zahlung ist eingegangen. Ich habe eine Benachrichtigung erhalten
              und melde mich zeitnah persönlich bei dir, um deinen Termin zu vereinbaren.
            </p>
          </>
        )}
        {state === "pending" && (
          <>
            <Loader2 size={40} className="text-[#93401D] mx-auto" />
            <h1 className="font-serif text-2xl text-[#29170C] mt-6">Zahlung in Bearbeitung</h1>
            <p className="text-[#63432B] mt-3 text-[15px] leading-relaxed">
              Deine Zahlung wird noch verarbeitet. Du erhältst eine Bestätigung,
              sobald sie abgeschlossen ist – ich melde mich dann bei dir.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="payment-success-home"
          className="btn-primary rounded-full px-8 py-3 text-sm font-medium inline-block mt-8"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
